import { gql } from "@apollo/client";

const CREATE_VOUCHER = gql(`
mutation CreateVoucher($input: CreateVoucherInput!) {
  createVoucher(input: $input) {
    code
    createdAt
    discount
    discountType
    events {
      general {
        name
      }
    }
    expiryDate
    id
    maxUsesPerEvent
    maxUsesTotal
    scope
    title
  }
}
`);

const SHOP_APPLY_VOUCHER = gql(`
  mutation ShopValidateApplyVoucher($code: String!, $eventId: String) {
  shopValidateApplyVoucher(code: $code, eventId: $eventId) {
    id
    code
    title
    expiryDate
    discount
    discountType
  }
}
`)

export {
  CREATE_VOUCHER,
  SHOP_APPLY_VOUCHER
};